"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSuperAdmin = exports.hasVektorioPerm = exports.hasSokoSitePerm = exports.hasSokoBidPerm = exports.hasOrdersPerm = exports.hasTeamPerm = exports.hasFilesPerm = exports.hasDistributionPerm = exports.hasCongridPerm = exports.hasAutomaticOrdersPerm = void 0;
var acl = require("@caddigital/sok-reducers/lib/utils/acl");
var hasAutomaticOrdersPerm = function (perm) {
    return acl.isProjectUser(perm) &&
        acl.hasGrant(perm, acl.AUTOMATIC_ORDER_PERM | acl.FILESTAB_PERM);
};
exports.hasAutomaticOrdersPerm = hasAutomaticOrdersPerm;
var hasCongridPerm = function (perm) {
    return acl.isProjectAdmin(perm) && acl.hasGrant(perm, acl.CONGRID_PERM);
};
exports.hasCongridPerm = hasCongridPerm;
var hasDistributionPerm = function (perm) {
    return acl.isProjectUser(perm) &&
        acl.hasGrant(perm, acl.ORDER_PERM | acl.FILESTAB_PERM);
};
exports.hasDistributionPerm = hasDistributionPerm;
var hasFilesPerm = function (perm) {
    return acl.isProjectUser(perm) && acl.hasGrant(perm, acl.FILESTAB_PERM);
};
exports.hasFilesPerm = hasFilesPerm;
var hasTeamPerm = function (perm) {
    return acl.isProjectAdmin(perm) || acl.isLightAdmin(perm) || acl.isSokoBidAdmin(perm);
};
exports.hasTeamPerm = hasTeamPerm;
var hasOrdersPerm = function (perm) {
    return acl.isProjectUser(perm) &&
        acl.hasGrant(perm, acl.ORDER_PERM) &&
        (acl.hasGrant(perm, acl.FILESTAB_PERM) ||
            acl.hasGrant(perm, acl.SOKOBID_PERM));
};
exports.hasOrdersPerm = hasOrdersPerm;
var hasSokoBidPerm = function (perm) {
    return acl.isSokoBidUser(perm) && acl.hasGrant(perm, acl.SOKOBID_PERM);
};
exports.hasSokoBidPerm = hasSokoBidPerm;
var hasSokoSitePerm = function (perm) {
    return (acl.isWorksiteDiaryMaster(perm) ||
        acl.isWorksiteDiarySupervisor(perm) ||
        acl.isWorksiteDiaryUser(perm) ||
        acl.isTrmvrMeterEmployer(perm) ||
        acl.isTrmvrMeterEmployee(perm) ||
        acl.isTrmvrMeterViewer(perm)) &&
        acl.hasGrant(perm, acl.SOKOSITE_PERM);
};
exports.hasSokoSitePerm = hasSokoSitePerm;
var hasVektorioPerm = function (perm) {
    return acl.isProjectAdmin(perm) && acl.hasGrant(perm, acl.VEKTORIO_PERM);
};
exports.hasVektorioPerm = hasVektorioPerm;
var isSuperAdmin = function (user) {
    return Boolean(user === null || user === void 0 ? void 0 : user.fold(false, function (_a) {
        var level = _a.level;
        return level === 'SuperAdminUserGroup';
    }));
};
exports.isSuperAdmin = isSuperAdmin;
